module.exports = __webpack_public_path__ + "static/media/sr.cc3cfa19.png";